//Do not add anything to this class. It will be removed in the future
import { teamRepository } from "../../storage/storage";
import FootballPlayEndContextSnapshot from "../../sports/football/context/football-play-end-context-snapshot";

export default class SummaryContextFactory {
    //TODO: Get rid of this class.
    build(contextSnapshot, gameContext) {
        const endContext = new FootballPlayEndContextSnapshot(contextSnapshot);
        const { homeTeamId, awayTeamId, gameConfig } = gameContext;
        const homeTeam = teamRepository.getFromCacheSync(homeTeamId);
        const awayTeam = teamRepository.getFromCacheSync(awayTeamId);

        Object.assign(endContext, {
            sopPrinted: false,
            eopPrinted: false,
            homeTeam,
            awayTeam,
            gameConfig
        });

        return endContext;
    }
}
